import api from './api';

const customerService = {
  // Get all customers
  getAllCustomers: async () => {
    const response = await api.get('/api/customers');
    return response.data;
  },

  // Get customer by ID
  getCustomerById: async (id) => {
    const response = await api.get(`/api/customers/${id}`);
    return response.data;
  },

  // Create customer
  createCustomer: async (customerData) => {
    const response = await api.post('/api/customers', customerData);
    return response.data;
  },

  // Update customer
  updateCustomer: async (id, customerData) => {
    const response = await api.put(`/api/customers/${id}`, customerData);
    return response.data;
  },

  // Delete customer
  deleteCustomer: async (id) => {
    const response = await api.delete(`/api/customers/${id}`);
    return response.data;
  },

  // Get customer summary/stats
  getCustomerStats: async () => {
    const response = await api.get('/api/customers/stats');
    return response.data;
  },
};

export default customerService;